export const getUserLocationEndpoint = locationId => `User/Location/${locationId}`;
export const getUserLocationsEndpoint = userId => `User/${userId}/Location`;